// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, nullValidation, string } from "@altostra/type-validations/lib/primitives";

export const isAppsAggregatePushCredentialInfoResult = recordOf({
  key: string,
  value: anyOf(boolean, nullValidation),
});

export const isTransformedAggregatePushInfoResult = objectOf({
  has_push_credential: boolean,
  android: objectOf({ configured: boolean }),
  ios: objectOf({ configured: boolean, expired: boolean }),
  kindle: objectOf({ configured: boolean }),
  safari: objectOf({ configured: boolean, image: anyOf(string, nullValidation) }),
  web: objectOf({ configured: boolean }),
});
